import * as React from "react";

import { makeStyles } from "@material-ui/styles";

import Table from "jazasoft/lib/mui/components/Table";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import { isEmpty } from "../../utils/helpers";
import KanbanCard from "./KanbanCard";
import FlowInfoCard from "./FlowInfoCard";

const useStyles = makeStyles({
  headerCell: {
    padding: "12px 12px",
    fontSize: 12,
    fontWeight: "bold",
    color: "#333333",
    textTransform: "uppercase",
    "&:last-child": {
      padding: "12px 12px",
      fontSize: 12,
      fontWeight: "bold",
      color: "#333333",
      textTransform: "uppercase"
    }
  },
  rowCell: {
    padding: "8px 12px",
    fontSize: 12,
    borderBottom: "none",
    "&:last-child": {
      padding: "8px 12px",
      fontSize: 12,
      borderBottom: "none"
    }
  }
});

const CustomDatagrid = props => {
  const classes = useStyles();
  const { data = {}, ids = [], utc_offset, unitList = [] } = props;
  const osList = ids.map(id => data[id]).filter(e => !isEmpty(e));

  const columns = [
    { dataKey: "flowInfo", title: "Order Details", element: <FlowInfoCard utc_offset={utc_offset} unitList={unitList} /> },
    {
      dataKey: "fabInhouse",
      title: "Fabric Inhouse",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="grnQty" startTimeKey="grnStartTime" endTimeKey="grnEndTime" />
    },
    {
      dataKey: "fabInspection",
      title: "Fabric Inspection",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="qcQty" startTimeKey="qcStartTime" endTimeKey="qcEndTime" />
    },
    {
      dataKey: "cutPlan",
      title: "Cut Plan",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="plannedQty" startTimeKey="planningStartTime" endTimeKey="planningEndTime" />
    },
    {
      dataKey: "fabRelease",
      title: "Fabric Release",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="releasedQty" startTimeKey="releaseStartTime" endTimeKey="releaseEndTime" />
    },
    // {
    //   dataKey: "spreading",
    //   title: "Spreading",
    //   align: 'center',
    //   element: <KanbanCard utc_offset={utc_offset} key="spreadQty" startTimeKey="spreadingStartTime" endTimeKey="spreadingEndTime" />
    // },
    // {
    //   dataKey: "cutting",
    //   title: "Cutting",
    //   align: 'center',
    //   element: <KanbanCard utc_offset={utc_offset} key="cutQty" startTimeKey="cuttingStartTime" endTimeKey="cuttingEndTime" />
    // },
    {
      dataKey: "cutting",
      title: "Cutting",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="spreadQty" startTimeKey="spreadingStartTime" endTimeKey="spreadingEndTime" />
    },
    {
      dataKey: "closed",
      title: "Closure",
      align: "center",
      element: <KanbanCard utc_offset={utc_offset} qtyKey="closedQty" startTimeKey="closureStartTime" endTimeKey="closureEndTime" />
    }
  ];

  if (isEmpty(osList)) return <div />;

  return (
    <PerfectScrollbar>
      <Table classes={classes} columns={columns} rows={osList} />
    </PerfectScrollbar>
  );
};

export default CustomDatagrid;
